import React from 'react';

import { Header, SerialNumbersList } from 'components';
import { PrivateRoute } from 'utils';

export const SerialNumbers = () => {
  PrivateRoute();

  return (
    <>
      <Header />
      <SerialNumbersList />
    </>
  );
};
